module.exports = __webpack_public_path__ + "img/api-doc.c94caa3a.svg";